import * as React from 'react';
import { TextAvatar, TextAvatarSize } from './TextAvatar';
import { Flex } from '../compositeComponents/FlexHelpers';
import { IconAvatar } from './IconAvatar';
import { PermissionGroup, AmorgUserRole, userHelper } from '../../amorg-common';
import { txt } from '../../txt';
import { Span12, Span14 } from '../typography/Body';

export type UserAvatarProps = {
    user?:{
        displayName:string,
        initials:string
    },
    identifier?:string,
    backgroundColorOverride?: string,
    size?: TextAvatarSize,
    selected?:boolean,
    extraTooltipRows?: string[],
    hideTooltip?:boolean,
    noUserTooltip?:React.ReactNode,
    onClick?: (identifier:string) => void
};

export function UserAvatar (props: UserAvatarProps): JSX.Element
{
    if(!props.user)
        return (
            <IconAvatar
                identifier={props.identifier || ''}
                icon='interface_user_user' 
                contentColor='#3d3737'
                backgroundColor='#eee8e8'
                size="32px"
                toolTip={props.noUserTooltip}
                onClick={props.onClick}
            />
        );

    let tooltip:React.ReactNode | undefined = undefined;
    if(!props.hideTooltip)
    {
        tooltip = (
            <Flex flexDirection="column" gap={2} alignItems='center'>
                <div>
                    <Span14 color="white">{props.user.displayName}</Span14>
                </div>
                {props.extraTooltipRows && props.extraTooltipRows.map((row, index) => (
                    <div key={index}>
                        <Span12 color="white">{row}</Span12>
                    </div>
                ))}
            </Flex>
        );
    }


    return (
        <TextAvatar size={props.size || '32px'}
            text={props.user.initials}
            identifier={props.identifier}
            onClick={props.onClick}
            colorGenerationString={props.backgroundColorOverride ? undefined : props.user.displayName}
            backgroundColor={props.backgroundColorOverride}
            toolTip={tooltip} 
        />
    );
}

type FullUserAvatarProps = {
    user?:{
        id:string,
        firstname:string,
        lastname:string,
        initials:string,
        permissionGroup: PermissionGroup,
        currentRole: AmorgUserRole | null,
    }
    backgroundColorOverride?: string,
    size?: TextAvatarSize,
    selected?:boolean,
    hideTooltip?:boolean,
    noUserTooltip?:React.ReactNode,
    onClick?: (identifier:string) => void
};

export function FullUserAvatar (props: FullUserAvatarProps): JSX.Element
{
    const extraTooltipRows:string[] = [];
    if(props.user)
    {
        extraTooltipRows.push(`${txt.getDynamic('PermissionGroupId_' +props.user.permissionGroup.id)}`);
        if(props.user.currentRole)
            extraTooltipRows.push(`${props.user.currentRole.title}`);
    }

    if(!props.user)
        return  <UserAvatar 
                    size={props.size || '32px'} 
                    user={undefined} 
                    identifier='' 
                    onClick={props.onClick} 
                    noUserTooltip={props.noUserTooltip} />;

    return (
        <UserAvatar size={props.size || '32px'}
            user={{
                displayName: userHelper.getPublicUserFullName({firstname: props.user.firstname, middlename:'', lastname: props.user.lastname}),
                initials: props.user.initials,
            }}
            identifier={props.user.id}
            selected={props.selected}
            onClick={props.onClick}
            backgroundColorOverride={props.backgroundColorOverride}
            hideTooltip={props.hideTooltip}
            extraTooltipRows={extraTooltipRows}
        />
    );
}
